import Vue from 'vue';
import Router from 'vue-router';
// base
import Login from './views/Base/Login';
import UcLogin from './views/Base/UcLogin';

// layout
import BaseAdmin from './layouts/BaseAdmin';
import PageLayout from './layouts/PageLayout';

// 稿件模块
import Article from './router/Article';

// 信源
import Data from './router/Bigdata';
// 第三方平台
import Third from './router/Third';

// 媒体库
import Cloud from './router/Cloud';

// task
import { Task, Report, Draft, Direct } from './router/Task';

// 站点管理
import ManageData from './router/Manage';

//其他设置
import ThirdParty from './router/ThirdParty';

//广告管理
import Advertisement from './router/Advertisement';

//专题模板
import Thematic from './router/Thematic';

//栏目管理
import CateManage from './router/CateManage';

//区域文章
import RegionArticle from './router/RegionArticle';

//APP广告管理
import Mobile from './router/Mobile';

//微信文章拉取
import WxPull from './router/WxPull';

//系统日志
import Logs from './router/Logs';
Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: '关于',
      redirect: '/Login'
    },
    {
      path: '/uclogin',
      name: 'UcLogin',
      component: UcLogin
    },
    {
      path: '/Login',
      name: '登录',
      component: Login
    },
    {
      path: '/index',
      name: 'index',
      redirect: '/Main/Manage/Census'
    },
    {
      path: '/Main',
      name: '控制台',
      component: BaseAdmin,
      children: [
        {
          path: 'Article',
          name: '文章管理',
          component: PageLayout,
          children: Article
        },
        {
          path: 'Manage',
          name: '站点管理',
          component: PageLayout,
          children: ManageData
        },
        {
          path: 'Cloud',
          name: '资源库',
          component: PageLayout,
          children: Cloud
        },
        {
          path: 'Data',
          name: '信源',
          component: PageLayout,
          children: Data
        },
        {
          path: 'Draft',
          name: '任务稿件',
          component: PageLayout,
          children: Draft
        },
        {
          path: 'Report',
          name: '报题管理',
          component: PageLayout,
          children: Report
        },
        {
          path: 'Task',
          name: '任务管理',
          component: PageLayout,
          children: Task
        },
        {
          path: 'Direct',
          name: '宣传指令',
          component: PageLayout,
          children: Direct
        },
        {
          path: 'Third',
          name: '第三方平台',
          component: PageLayout,
          children: Third
        },
        {
          path: 'ThirdParty',
          name: '其他设置',
          component: PageLayout,
          children: ThirdParty
        },
        {
          path: 'Advertisement',
          name: '广告服务',
          component: PageLayout,
          children: Advertisement
        },
        {
          path: 'Thematic',
          name: '专题模板',
          component: PageLayout,
          children: Thematic
        },
        {
          path: 'CateManage',
          name: '栏目权限',
          component: PageLayout,
          children: CateManage
        },
        {
          path: 'RegionArticle',
          name: '区域文章',
          component: PageLayout,
          children: RegionArticle
        },
        {
          path: 'Mobile',
          name: 'APP管理',
          component: PageLayout,
          children: Mobile
        },
        {
          path: 'WxPull',
          name: '微信文章拉取',
          component: PageLayout,
          children: WxPull
        },
        {
          path: 'Logs',
          name: '系统日志',
          component: PageLayout,
          children: Logs
        }
      ]
    },
    {
      path: '/',
      name: '首页',
      redirect: '/main/Article/Add/'
    }
  ]
});
